import { render, staticRenderFns } from "./smartControl_analysis.vue?vue&type=template&id=202b80a7&scoped=true"
import script from "./smartControl_analysis.vue?vue&type=script&lang=js"
export * from "./smartControl_analysis.vue?vue&type=script&lang=js"
import style0 from "./smartControl_analysis.vue?vue&type=style&index=0&id=202b80a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b80a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202b80a7')) {
      api.createRecord('202b80a7', component.options)
    } else {
      api.reload('202b80a7', component.options)
    }
    module.hot.accept("./smartControl_analysis.vue?vue&type=template&id=202b80a7&scoped=true", function () {
      api.rerender('202b80a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/smartControl/smartControl_analysis.vue"
export default component.exports